import React, {useState, forwardRef } from 'react';
import { makeStyles } from '@material-ui/styles';
import MaterialTable from 'material-table';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import Password from './components/Password';
import { Popover, List, ListItem, ListItemText } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';

const tableIcons = {
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
  };

const useStyles = makeStyles({
    popper: {
      width: 120,
      margin: '0 24px 0 0',
      //boxShadow: isMobile ? 'initial' : '0 2px 5px 0 rgba(0, 0, 0, 0.2)',
      //backgroundColor: isMobile ? 'initial' : '#f5f5f5',
    },
    list: {
      width: 120,
      backgroundColor: 'white',
    },
    listItem: {
      '&:hover': {
        backgroundColor: '#f5f5f5',
      },
    },
    listItemText: {
      color: '#484848',
      fontSize: 14,
    },
  });

const ContactCenterList = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [outsideOpen, setOutsideOpen] = useState(false);
  const [flagEdit, setFlagEdit] = useState(0);

  const handleOutside = () => {
    setOutsideOpen(!outsideOpen);
  };

  const openPopper = Boolean(anchorEl);

  const handlePopper = (event, nElem) => {
    if (flagEdit === 1) { 
      setFlagEdit(0)         
    }
    //setElemIndex(nElem);
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  return (
    <>
      <div style={{ maxWidth: '100%' }}>
        <MaterialTable
            icons={tableIcons}
          columns={[
            { title: 'Nombre completo', field: 'name' },
            { title: 'Correo electrónico', field: 'email' },
            {
              title: 'Contraseña',
              field: 'password',
              type: 'password',
              render: (rowData) => (
                <Password passwordValue={rowData.password} />
              ),
            },
            {
              title: 'Fecha de registro',
              field: 'signUpDate',
              type: 'date',
            },
          ]}
          actions={[
            {
              icon: () => <MoreHorizIcon color='primary' />,
              onClick: (event, rowData) => {
                // Do save operation
                handlePopper(event)
              },
            },
          ]}
          data={[
            {
              name: 'Yazmin Pedraza',
              email: 'pyazmin@mail.com',
              password: '123456789',
              signUpDate: '13/01/2020',
            },
            {
              name: 'Alonso Antonio Romero Rubio',
              email: 'alonso.ejemplo.correo@outlook.com',
              password: '123456789',
              signUpDate: '13/01/2020',
            },
            {
              name: 'Alejandro Contla Flores',
              email: 'ejemplodecorreo@outlook.com',
              password: '12345678942342332543',
              signUpDate: '13/01/2020',
            },
          ]}
          options={{
            actionsColumnIndex: -1,
            toolbar: false,
            draggable: false,
            sorting: false,
            headerStyle: {
                color: '#013957',
                textAlign: 'center',
                fontWeight: 'bold',
                fontSize: 16
              },
            rowStyle:
                rowData => ({
                    backgroundColor: (rowData.tableData.id % 2 === 0) ? '#fff' : 'rgba(245, 245, 245, 0.4)',
                    color: '#484848',
                  })
            
          }}
          localization={{
            header: {
              actions: 'Opciones',
            },
            pagination: {
                labelRowsSelect: 'Filas por página',
                labelDisplayedRows: '{from}-{to} de {count}'
            }
          }}
        />
      </div>
      <Popover
            open={openPopper}
            anchorEl={anchorEl}
            className={classes.popper}
            onClose={() => setAnchorEl(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
          >
            <List
              className={classes.list}
              component="nav"
              aria-label="secondary mailbox folders"
            >
              <ListItem className={classes.listItem} button>
                <ListItemText
                  //onClick={FnEditAward}
                  className={classes.listItemText}
                  primary="Editar"
                />
              </ListItem>

              <ListItem className={classes.listItem} button>
                <ListItemText
                  onClick={handleOutside}
                  className={classes.listItemText}
                  primary="Eliminar"
                />
              </ListItem>
            </List>
          </Popover>
    </>
  );
};

export default ContactCenterList;
